import React from 'react';

export function MaintenanceMode() {
    return (
        <div
            className="gds-flex gds-flex--direction-col gds-flex--content-center gds-flex--justify-around -text-center"
            style={{
                height: '100vh',
            }}
        >
            <div className="gds-flex__item gds-flex__item--grow-0">
                <i
                    className="fas fa-fw fa-cogs gds-text--header-xxl gds-text--primary"
                    style={{
                        fontSize: '6rem',
                    }}
                />
                <i
                    className="fas fa-fw fa-wrench -color-tx-dk-5"
                    style={{
                        fontSize: '2.8rem',
                        position: 'relative',
                        bottom: '2rem',
                        right: '1rem',
                    }}
                />
                <p className="gds-text--header-sm -m-t-4">
                    MVC is currently undergoing some maintenance.
                </p>
                <p className="gds-text--header-sm -m-t-2">
                    We will be back soon!
                </p>
            </div>
        </div>
    );
}

export default MaintenanceMode;
